module.exports = __webpack_public_path__ + "static/banner-6d7bf792b9395cb439e8a40fea2a6a49.jpg";